export const navHeaderActive = () => {
	const navBar = document.querySelector('.nav__bar.hidden-md');
	if (!navBar) return;
	const currentPath = window.location.pathname.replace(/\/$/, '') || '/';
	navBar.querySelectorAll(':scope > li > a').forEach(a => {
		const linkPath = new URL(a.href, window.location.origin).pathname.replace(/\/$/, '') || '/';
		if (linkPath === currentPath) {
			a.classList.add('active-tab');
		}
	});
}
